import LineChart from './LineGraph'
import AreaChart from './AreaRealtimeGraph'
import CombineChart from './CombineGraph'
import MultiGraph from './MultiGraph'

export default { LineChart, AreaChart, CombineChart, MultiGraph }
